<template>
  <div class="FamousCooperativeEnterprises">
    <div class="module animated">
      <title-name :name="'合作名企'"></title-name>
      <img v-lazy="require('@/common/images/talent/index/hzmq.png')" alt="合作名企">
    </div>
  </div>
  <!-- end 合作名企 -->
</template>

<script>
import $ from 'jquery'
import {mapGetters, mapActions} from 'vuex'
import TitleName from '../../components/TitleName'
export default {
  name: 'FamousCooperativeEnterprises',
  data () {
    return {}
  },
  mounted () {
    if (this.animationScrool) {
      window.addEventListener('scroll', this.animationScrool)
    }
    this.animationScrool()
    $(window).bind("scroll",function(){  
      if (this.animationScrool) {
        this.animationScrool()
      }
    });
  },
  methods: {
    animationScrool() { // 鼠标滚动事件监控，进行动画 top 动画事件
            let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop // 滚动条偏移量
            // console.log(scrollTop)
            // 添加滚动条
            if (this.$route.name == "TalentIndex") {
              if (scrollTop > 2000) {
                  if (!$(".FamousCooperativeEnterprises .module").hasClass('fadeInUp')) {
                      $(".FamousCooperativeEnterprises .module").addClass('fadeInUp')
                  }
              }
            }
            
        },
       ...mapActions([
            'setLoading'
        ])
  },
  filters: {},
  watch: {},
  computed: {
    ...mapGetters([
        'user'
    ])
  },
  components: {
      TitleName
  }
}
</script>

<style lang="scss" type="text/scss" scoped>
.FamousCooperativeEnterprises {
  padding-top: 40px;
  padding-bottom: 70px;
  background: #fff;
  .animated {
    opacity: 0;
  }
  .fadeInUp{
    opacity: 1;
  }
  img {
    margin-top: 30px;
    width: 1200px;
    height: 280px;
    background: #ccc;
  }
}
</style>